<template>
  <div>
    <div class="survey-form">
      <!-- First Name -->
      <div v-if="allFields['firstName']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.firstName }}
          {{ fieldRequired('First Name') ? ' *' : '' }}
        </h4>
        <input type="text" v-model="guest.firstName.value" />
      </div>

      <!-- Last Name -->
      <div v-if="allFields['lastName']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.lastName }}
          {{ fieldRequired('Last Name') ? ' *' : '' }}
        </h4>
        <input type="text" v-model="guest.lastName.value" />
      </div>

      <!-- Email -->
      <div v-if="allFields['email']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.email }}
          {{ fieldRequired('Email') ? ' *' : '' }}
        </h4>
        <input type="email" v-model="guest.email.value" />
        <span
          v-if="!isEmailValid && guest.email.value.length > 0"
          class="error-msg"
        >
          {{ strings.validEmail }}
          <div><br /></div
        ></span>
      </div>

      <!-- Room Number -->
      <div v-if="allFields['roomNumber']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.roomNumber }}
          {{ fieldRequired('Room Number') ? ' *' : '' }}
        </h4>
        <input type="text" v-model="guest.roomNumber.value" />
        <span v-if="isRoomValid" class="error-msg">
          {{ strings.validRoom }}
          <div><br /></div
        ></span>
      </div>
      <!-- Phone Number -->
      <div v-if="allFields['phoneNumber']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.phoneNumber }}
          {{ fieldRequired('Phone Number') ? ' *' : '' }}
        </h4>
        <input type="text" v-model="guest.phoneNumber.value" />
        <span v-if="isPhoneValid" class="error-msg">
          {{ strings.validPhone }}
          <div><br /></div
        ></span>
      </div>

      <!-- Country-->
      <div v-if="allFields['nationalityCode']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.nationalityCode }}
          {{ fieldRequired('Country') ? ' *' : '' }}
          <countrypicker v-model="guest.nationalityCode.value"></countrypicker>
        </h4>
      </div>

      <!-- Check In Date -->
      <div v-if="allFields['checkInDate']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.checkInDate }}
          {{ fieldRequired('Check In Date') ? ' *' : '' }}
        </h4>
        <datepicker
          v-model="guest.checkInDate.value"
          v-if="allFields['checkInDate']"
          required
        >
        </datepicker>
      </div>

      <!-- Check Out Date -->
      <div v-if="allFields['checkOutDate']" class="form-group">
        <h4 class="label" :style="{ color: colorOptions.baseColor }">
          {{ strings.checkOutDate }}
          {{ fieldRequired('Check Out Date') ? ' *' : '' }}
        </h4>
        <datepicker
          v-model="guest.checkOutDate.value"
          v-if="allFields['checkOutDate']"
          required
        >
        </datepicker>
      </div>
    </div>

    <!-- Error -->
    <div v-if="error != ''" class="error">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Datepicker from 'vuejs-datepicker'
import Countrypicker from './CountrySelector'
import _ from 'lodash'
export default {
  components: {
    Datepicker,
    Countrypicker
  },
  props: {
    infoFields: {
      type: Array
    },
    colorOptions: Object,
    error: String,
    lang: {
      type: String,
      default: 'eng'
    },
    required: Boolean
  },
  computed: {
    isEmailValid() {
      const email = this.guest.email.value
      return email && /\S+@\S+\.\S+/.test(email)
    },
    isPhoneValid() {
      const phone = this.guest.phoneNumber.value
      return phone && !/^[\+0-9-\w]{7,21}$/.test(phone)
    },
    isRoomValid() {
      const room = this.guest.roomNumber.value
      return (
        room &&
        !/^[a-zA-Z0-9]{1,6}$/.test(
          room
        )
      )
    },

    // @TODO - Add validation for Room Number
    strings() {
      if (this.lang in this.langs) {
        return this.langs[this.lang]
      }
      return {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        roomNumber: 'Room Number',
        phoneNumber: 'Phone Number',
        nationalityCode: 'Country',
        checkInDate: 'Check in Date',
        checkOutDate: 'Check out Date',
        validEmail: 'Please enter a valid email address',
        validPhone: 'Please enter a valid phone number',
        validRoom: 'Please enter a valid room number',
      }
    }
  },

methods: {
    getTokenFromUrl() {
      const url = new URL(window.location.href);
      return url.pathname.split('/').pop();
    },

    decodeJwt(token) {
      if (!token || token.split('.').length < 2) {
        return ;
      }
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );

        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error("Failed to decode JWT", e);
        return null;
      }
    },
    updateGuestFromToken() {
      const token = this.getTokenFromUrl();
      const decodedPayload = this.decodeJwt(token);

      if(!decodedPayload){
        return;
      }
      else if (decodedPayload.user) {
        this.guest.email.value = decodedPayload.user.email || "";
        this.guest.firstName.value = decodedPayload.user.first_name || "";
        this.guest.lastName.value = decodedPayload.user.last_name || "";
      }
    },
    fieldRequired(fieldName) {
      return Object.values(this.allFields).find(
        field => field.name === fieldName && field.required === true
      )
    },
    mapInfoFields() {
      this.allFields = {}
      this.infoFields.forEach(fieldEntry => {
        let fields = JSON.parse(fieldEntry.fields)
        fields.forEach(curField => {
          let key = _.camelCase(curField.value)
          this.allFields[key] = curField
        })
      })
    },
    addRequiredFieldsToGuest() {
      for (let field in this.allFields) {
        if (this.allFields[field].required === true) {
          this.guest[field].required = true
        }
      }
    }
  },
  created() {
    if (this.infoFields.length > 0) this.mapInfoFields()
  },
  mounted() {
    this.addRequiredFieldsToGuest();
    this.updateGuestFromToken();
  },
  data() {
    return {
      allFields: {
        firstName: { name: 'First Name', required: false },
        lastName: { name: 'Last Name', required: false },
        email: { name: 'Email', required: false },
        roomNumber: { name: 'Room Number', required: false },
        nationalityCode: { name: 'Country', required: false },
        checkInDate: { name: 'Check In Date', required: false },
        checkOutDate: { name: 'Check Out Date', required: false },
        phoneNumber: { name: 'Phone Number', required: false }
      },
      guest: {
        firstName: { value: '', required: false },
        lastName: { value: '', required: false },
        email: { value: '', required: false },
        roomNumber: { value: '', required: false },
        checkInDate: { value: '', required: false },
        checkOutDate: { value: '', required: false },
        phoneNumber: { value: '', required: false },
        nationalityCode: { value: '', required: false }
      },
      langs: {
        ell: {
          firstName: 'Όνομα',
          lastName: 'Επώνυμο',
          email: 'Email',
          roomNumber: 'Αριθμός Δωματίου',
          checkInDate: 'Ημ/νια άφιξης',
          checkOutDate: 'Ημ/νια αναχώρησης',
          nationalityCode: 'Χώρα',
          phoneNumber: 'Τηλέφωνο',
          validEmail: 'Παρακαλώ εισάγετε ένα έγκυρο email',
          validRoom: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό δωματίου',
          validPhone: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό τηλεφώνου',
        },
        nld: {
          firstName: 'Naam',
          lastName: 'Achternaam',
          email: 'Email',
          roomNumber: 'Kamernummer',
          checkInDate: 'Check-in Datum',
          checkOutDate: 'Check-out Datum',
          nationalityCode: 'Land',
          phoneNumber: 'Telefoonnummer',
          validEmail: 'Voer een geldig e-mailadres in',
          validRoom: 'Voer een geldig kamernummer in',
          validPhone: 'Voer een geldig telefoonnummer in',
        },
        deu: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'Email',
          roomNumber: 'Zimmernummer',
          checkInDate: 'Check-in Datum',
          checkOutDate: 'Check-out Datum',
          nationalityCode: 'Land',
          phoneNumber: 'Telefonnummer',
          validEmail: 'Bitte geben Sie eine gültige E-Mail ein',
          validRoom: 'Bitte geben Sie eine gültige Zimmernummer ein',
          validPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
        },
        tur: {
          firstName: 'İsim',
          lastName: 'Soyadı',
          email: 'Eposta',
          roomNumber: 'Oda Numarası',
          checkInDate: 'Giriş Tarihi',
          checkOutDate: 'Çıkış Tarihi',
          nationalityCode: 'Ülke',
          phoneNumber: 'Telefon Numarası',
          validEmail: 'Lütfen geçerli bir e-posta girin',
          validRoom: 'Lütfen geçerli bir Oda Numarası girin',
          validPhone: 'Lütfen geçerli bir Telefon Numarası girin',
        },
        ita: {
          firstName: 'Il nome',
          lastName: 'Cognome',
          email: 'Email',
          roomNumber: 'Numero di Camera',
          checkInDate: 'Data di Arrivo',
          checkOutDate: 'Data di Partenza',
          nationalityCode: 'Nazione',
          phoneNumber: 'Numero di Telefono',
          validEmail: 'Inserire un indirizzo email valido',
          validRoom: 'Inserire un numero di camera valido',
          validPhone: 'Inserire un numero di telefono valido',
        },
        zho: {
          firstName: '姓名',
          lastName: '姓',
          email: '电子邮件',
          roomNumber: '房间号',
          checkInDate: '注册日期',
          checkOutDate: '出发日期',
          nationalityCode: '国家',
          phoneNumber: '电话号码',
          validEmail: '请输入有效的电子邮件',
          validRoom: '请输入有效的房间号',
          validPhone: '请输入有效的电话号码',
        },
        rus: {
          firstName: 'Имя',
          lastName: 'Фамилия',
          email: 'Электронный Адрес',
          roomNumber: 'Номер Комнаты',
          checkInDate: 'Дата Прибытия',
          checkOutDate: 'Дата Отбытия',
          nationalityCode: 'Страна',
          phoneNumber: 'Номер телефона',
          validEmail: 'Пожалуйста, введите действительный адрес электронной почты',
          validRoom: 'Пожалуйста, введите действительный номер комнаты',
          validPhone: 'Пожалуйста, введите действительный номер телефона',
        },
        fra: {
          firstName: 'Nom',
          lastName: 'Nom De Famille',
          email: "Envoyer L'adresse Par E-mail",
          roomNumber: 'Le Numéro De Chambre',
          checkInDate: "Date D'arrivée",
          checkOutDate: 'Date De Départ',
          nationalityCode: 'Pays',
          phoneNumber: 'Numéro de Téléphone',
          validEmail: 'Veuillez saisir une adresse électronique valide',
          validRoom: 'Veuillez entrer un numéro de chambre valide',
          validPhone: 'Veuillez saisir un numéro de téléphone valide',
        },
        ukr: {
          firstName: "Ім'я",
          lastName: 'Прізвище',
          email: 'Надішліть Адресу Електронною Поштою',
          roomNumber: 'Номер Кімнати',
          checkInDate: 'Дата Прибуття',
          checkOutDate: 'Дата Відправлення',
          nationalityCode: 'Країна',
          phoneNumber: 'Номер телефону',
          validEmail: 'Будь ласка, введіть дійсну адресу електронної пошти',
          validRoom: 'Будь ласка, введіть дійсний номер кімнати',
          validPhone: 'Будь ласка, введіть дійсний номер телефону',
        },
        sqi: {
          firstName: 'Emri',
          lastName: 'Mbiemri',
          email: 'Dërgo Email Adresën',
          roomNumber: 'Numri I Dhomës',
          checkInDate: 'Data E Mbërritjes',
          checkOutDate: 'Data E Nisjes',
          nationalityCode: 'Vendi',
          phoneNumber: 'Numri i Telefonit',
          validEmail: 'Ju lutemi shkruani një adresë të vlefshme emaili',
          validRoom: 'Fut një numër të vlefshëm dhome',
          validPhone: 'ju lutem vendosni nje numer telefoni te vlefshem',
        },
        ara: {
          firstName: 'اسم',
          lastName: 'لقب',
          email: 'أرسل العنوان بالبريد الإلكتروني',
          roomNumber: 'رقم الغرفة',
          checkInDate: 'تاريخ الوصول',
          checkOutDate: 'تاريخ المغادرة',
          nationalityCode: 'بلد',
          phoneNumber: 'رقم الهاتف',
          validEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
          validRoom: 'الرجاء إدخال رقم غرفة صحيح',
          validPhone: 'يرجى إدخال رقم هاتف صالح',
        },
        fas: {
          firstName: 'نام',
          lastName: 'نام خانوادگی',
          email: 'آدرس را ایمیل کنید',
          roomNumber: 'شماره اتاق',
          checkInDate: 'تاریخ ورود',
          checkOutDate: 'تاریخ حرکت',
          nationalityCode: 'کشور',
          phoneNumber: 'شماره تلفن',
          validEmail: 'لطفا یک آدرس ایمیل معتبر وارد کنید',
          validRoom: 'لطفا یک شماره تلفن معتبر وارد کنید',
          validPhone: 'لطفاً یک شماره اتاق معتبر وارد کنید',
        }
      }
    }
  },
  watch: {
    guest: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit('details-updated', newValue)
      }
    }
  }
}
</script>

<style scoped>
.error-msg {
  color: red;
  font-size: 15px;
}
h4.label {
  font-size: 15px !important;
  font-weight: 700;
  margin-bottom: 4px;
  margin-top: 0;
}

.survey-form {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  margin-top: 40px;
}

.survey-form .form-group {
  width: 50%;
  min-width: 300px;
}

input[type='text'],
input[type='email'] {
  border-radius: 4px;
  border: solid 1px #bfc0c8;
  width: 100%;
  max-width: 300px;
  margin-bottom: 16px;
  padding: 4px;
  height: 24px;
  min-height: 24px;
}
</style>

<style>
.vdp-datepicker input[type='text'] {
  border-radius: 4px;
  border: solid 1px #bfc0c8;
  width: 100%;
  max-width: 200px;
  margin-bottom: 16px;
  height: 34px;
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/GenericForm.vue